/**
 * @file CommitmentController
 * @description
 * Load into your application like `myApp.controller('CommitmentController', require('CommitmentController.js'))`
 */
module.exports = ["$scope", "$filter", "AppConstants", "CTServiceAPIConfig", "CTHashService", "POPUP_HASH_KEY", function($scope, $filter, AppConstants, CTServiceAPIConfig, CTHashService, POPUP_HASH_KEY) {
    var _controller = this,
        _item = () => ($scope.item || {});


    /**
     * Check if an image is available
     * @return {boolean}
     */
    _controller.hasImage = () => !!_item().image && !!_item().image_id;

    /**
     * Check if a statement is available
     * @return {boolean}
     */
    _controller.hasMessage = () => !!_item().message;

    /**
     * Return a trusted HTML String for angular
     * @return {*}
     */
    _controller.getHTMLSafeMessage = () => $filter('parseLinks')(_item().message || AppConstants.COMMITMENT_DEFAULT_MESSAGE || '');

    /**
     * Return the popup hash
     */
    _controller.getPopupLink = () => CTHashService.getHash({[POPUP_HASH_KEY]: _item().id});

    /**
     * Generate a share url for this commitment
     * @return {string}
     */
    _controller.getShareURL = () => {
        const redirect_url = encodeURIComponent(`${location.protocol}//${location.hostname}${location.pathname}#commitment=${_item().id}`);
        return `${CTServiceAPIConfig.HOST}/api/v1/pages/${AppConstants.PAGE_ID}/commitments/${_item().id}/share?redirect_url=${redirect_url}`;
    };

    (function init() {

    }());
}];
